// extracted by mini-css-extract-plugin
export default {"solutionCard":"SolutionCard_solutionCard__zZqAU","linkWrapper":"SolutionCard_linkWrapper__hugVg"};